import { Avatar, AvatarBadge, Flex, Image, Text } from "@chakra-ui/react";
import img from "../../assets/livestream_photo.jpeg";
function VideoCallUserCard({ fullScreen, name, userActive, ...props }) {
  return (
    <Flex
      w={["100%", "300px", "300px", "300px"]}
      h={["200px", "300px", "300px", "300px"]}
      position={["relative", "relative", "relative"]}
      borderRadius="25px"
      overflow={"hidden"}
      {...props}
    >
      <Image
        position={"absolute"}
        w="100%"
        h="100%"
        src={img}
        alt="video call card"
        objectFit={"cover"}
      />
      <Flex
        flexDirection={"row"}
        position="absolute"
        left={"7px"}
        bottom="15px"
        alignItems={"center"}
        gap="10px"
      >
        <Avatar border="2px solid #fff" src={img} size="xs">
          {userActive && <AvatarBadge boxSize=".7em" bg="#38F135" />}
        </Avatar>
        <Text color="#fff" fontWeight={"700"} fontSize=".7em">
          {name}
        </Text>
      </Flex>
    </Flex>
  );
}

export default VideoCallUserCard;
